var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 462,
    height: 442,
    viewBox: "0 0 462 442",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220.801 441.602C99.0505 441.602 0 342.551 0 220.801C0 99.0505 99.0505 0 220.801 0C342.551 0 441.602 99.0505 441.602 220.801C441.602 342.551 342.551 441.602 220.801 441.602ZM220.801 55.6641C129.744 55.6641 55.6641 129.744 55.6641 220.801C55.6641 311.858 129.744 385.938 220.801 385.938C311.858 385.938 385.938 311.858 385.938 220.801C385.938 129.744 311.858 55.6641 220.801 55.6641Z",
    fill: "#00607F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M220.994 291.791C213.611 291.791 206.532 288.859 201.315 283.638L142.416 224.738C131.547 213.868 131.547 196.247 142.416 185.378C153.284 174.51 170.907 174.506 181.776 185.378L220.996 224.599L414.124 31.4684C424.991 20.5991 442.615 20.5991 453.484 31.4684C464.353 42.3359 464.353 59.9591 453.484 70.8285L240.673 283.638C235.453 288.859 228.375 291.791 220.994 291.791Z",
    fill: "#00DDC1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M220.801 0V55.6641C311.858 55.6641 385.938 129.744 385.938 220.801C385.938 311.858 311.858 385.938 220.801 385.938V441.602C342.551 441.602 441.602 342.551 441.602 220.801C441.602 99.0505 342.551 0 220.801 0Z",
    fill: "#002C3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M453.484 31.4684C442.617 20.5991 424.993 20.5991 414.124 31.4684L220.994 224.599L220.801 224.406V291.78C220.866 291.78 220.929 291.789 220.994 291.789C228.377 291.789 235.455 288.857 240.673 283.636L453.484 70.8266C464.355 59.9591 464.355 42.3359 453.484 31.4684Z",
    fill: "#00AB94"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYes);
export default __webpack_public_path__ + "static/media/yes.87c8fde4a0a02014b0be7163edc814a3.svg";
export { ForwardRef as ReactComponent };